module.exports = __webpack_public_path__ + "static/media/teapot-gardens.a100a472.PNG";